import { useCallback, useEffect, useState } from "react";

const initialState = {
  error: undefined,
  loading: true,
  data: undefined
};

export const useApi = apiFn => {
  const [state, setState] = useState(initialState);

  const invokeApi = useCallback(() => {
    setState(initialState);
    apiFn()
      .then(data => {
        setState({
          loading: false,
          error: undefined,
          data
        });
      })
      .catch(error => {
        setState({
          loading: false,
          error,
          data: undefined
        });
      });
  }, [apiFn]);

  useEffect(() => {
    invokeApi();
  }, [invokeApi]);

  return { ...state, invokeApi };
};
